export const CONNECT_DUPR_MODAL_KEY = 'connect_dupr_modal_key';
export const FORBIDEN_ROUTE = '/failed-membership';
export const FORBIDEN_ROUTE_2 = '/profile/connect-dupr';
export const DEFAULT_EXPIRATION = 24 * 60 * 60 * 1000;
